import catalogMetadata from "../data/catalogPosterMetadata.json";
import { publicAsset } from "./publicAsset.mjs";
import { resolveVerifiedTMDBMetadata } from "./tmdbMetadata.mjs";

export async function moviePosterMetadata(movieId, canonicalTitle, tmdbId, imdbId) {
  const cached = catalogMetadata[movieId];
  if (cached && cached.canonical_title === canonicalTitle && cached.tmdb_id === Number(tmdbId)) {
    const local = publicAsset(`pilot-posters/${Number(movieId)}.jpg`);
    return { ...cached, poster_url: local, poster_urls: [local, ...cached.poster_urls].slice(0, 3) };
  }
  return resolveVerifiedTMDBMetadata({ movieId, canonicalTitle, tmdbId, imdbId,
    apiKey: process.env.REACT_APP_TMDB_API_KEY || "" });
}
